import { Milestone } from '@/models/leaderboard';
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';

@Component({
  name: 'CmgLeaderboardMilestoneCompletedModal',
})
export default class CmgLeaderboardMilestoneCompletedModal extends Vue {

  @Watch('visible')
  handleVisibleChange(newValue: boolean) {
    if (newValue) {
      // Wait for next tick to ensure the modal args (milestone) have been updated in the store
      this.$nextTick(() => {
        localStorage.setItem(`summerLeaderboardMilestoneCompletedShown_${this.milestone?.month}_${this.milestone?.segment}`, 'true');
      });
    }
  }

  @Watch('milestone')
  handleMilestoneChange(newValue: Milestone | undefined) {
    // If the modal is already visible and the milestone changes (e.g. parent batches close+reopen in one tick),
    // the visible watcher won't fire — so mark the new milestone as shown here.
    if (newValue && this.visible) {
      localStorage.setItem(`summerLeaderboardMilestoneCompletedShown_${newValue.month}_${newValue.segment}`, 'true');
    }
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.summerLeaderboardMilestoneCompleted.visible;
  }

  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get milestone(): Milestone | undefined {
    return this.$appStore.state.ui.modals.summerLeaderboardMilestoneCompleted.args?.milestone;
  }

  get title(): string {
    return this.milestone ? `Milestone ${this.milestone.segment} Unlocked` : '';
  }
  
  get rewardImage(): string {
    return this.milestone ? this.milestone.mediaUri : '';
  }

  get lottieBackgroundSparklesUrl(): string {
      return this.$appStore.state.cms.animations.bag.lottieBackgroundSparklesUrl;
  }

  onClickContinue() {
    this.$services.ui.setModalVisibility('summerLeaderboardCyoReward', true, { milestone: this.milestone });
    this.$services.ui.setModalVisibility('summerLeaderboardMilestoneCompleted', false);
  }

  onClose() {
    this.$services.ui.setModalVisibility('summerLeaderboardMilestoneCompleted', false);
  }
}
